import { render, staticRenderFns } from "./Contact-Profile.vue?vue&type=template&id=6fad6fde"
import script from "./Contact-Profile.vue?vue&type=script&lang=js"
export * from "./Contact-Profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports